import React from 'react';
import Logoo from "../../../assets/images/auth/Logo.svg";
import { useNavigate } from 'react-router-dom';


const PasswordReset: React.FC = () => {

  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <img src={Logoo} alt="logo" width="450" height="460" style={{ marginTop: '0%' }} />
        </div>

      </div>
      <div className="login-right">
        <div className="login-form">
          <h1>Password reset</h1>
          <p>Your password has been successfully reset.</p>
          <p>Click below to log in magically.</p>
          <div >
            <button type="submit" className="login-button" onClick={handleClick} >
              Continue
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}

export default PasswordReset;
